export const getTechIcon = (tech) => {
    const icons = {
        'React': 'fab fa-react',
        'Node.js': 'fab fa-node-js',
        'MongoDB': 'fas fa-database',
        'Firebase': 'fas fa-fire',
        'Flutter': 'fas fa-mobile-alt',
        'HTML5': 'fab fa-html5',
        'CSS3': 'fab fa-css3-alt',
        'JavaScript': 'fab fa-js',
        'Python': 'fab fa-python',
        'AWS': 'fab fa-aws',
        'Docker': 'fab fa-docker',
        'Git': 'fab fa-git-alt',
        'Redis': 'fas fa-server',
        'GraphQL': 'fas fa-project-diagram',
        'TypeScript': 'fas fa-code',
        'GSAP': 'fas fa-animation',
        'Stripe': 'fab fa-stripe',
        'default': 'fas fa-code'
    };
    return icons[tech] || icons.default;
};

export const getFeatureIcon = (featureTitle) => {
    const icons = {
        'Real-time Analytics': 'fas fa-chart-line',
        'Custom Reports': 'fas fa-file-alt',
        'Performance Metrics': 'fas fa-tachometer-alt',
        'Data Security': 'fas fa-shield-alt',
        'Real-time Tracking': 'fas fa-map-marker-alt',
        'Secure Payments': 'fas fa-lock',
        'Restaurant Dashboard': 'fas fa-store',
        'Smart Recommendations': 'fas fa-brain',
        'Responsive Design': 'fas fa-mobile-alt',
        'Smooth Animations': 'fas fa-magic',
        'Project Showcase': 'fas fa-images',
        'Contact Integration': 'fas fa-envelope',
        'Product Management': 'fas fa-box',
        'Secure Checkout': 'fas fa-shopping-cart',
        'User Accounts': 'fas fa-user',
        'Analytics Dashboard': 'fas fa-chart-bar',
        'default': 'fas fa-star'
    };
    return icons[featureTitle] || icons.default;
}; 